import { PureProps } from './config'

export const data1: PureProps = {
  compositionId: 'pure',
  config: { wrap: true, scale: 1, noAuthorLabel: false },
  translators: null,
  poem: 'Da ich ein Knabe war,\n' +
    "Rettet' ein Gott mich oft\n" +
    'Vom Geschrei und der Rute der Menschen,\n' +
    "Da spielt' ich sicher und gut\n" +
    'Mit den Blumen des Hains,\n' +
    'Und die Lüftchen des Himmels\n' +
    'Spielten mit mir.\n' +
    '\n' +
    'Und wie du das Herz\n' +
    'Der Pflanzen erfreust,\n' +
    'Wenn sie entgegen dir\n' +
    'Die zarten Arme strecken,\n' +
    '\n' +
    'So hast du mein Herz erfreut\n' +
    'Vater Helios! und, wie Endymion,\n' +
    'War ich dein Liebling,\n' +
    'Heilige Luna!\n' +
    '\n' +
    'Oh all ihr treuen\n' +
    'Freundlichen Götter!\n' +
    'Daß ihr wüßtet,\n' +
    'Wie euch meine Seele geliebt!\n' +
    '\n' +
    'Zwar damals rief ich noch nicht\n' +
    'Euch mit Namen, auch ihr\n' +
    'Nanntet mich nie, wie die Menschen sich nennen\n' +
    'Als kennten sie sich.\n' +
    '\n' +
    "Doch kannt' ich euch besser,\n" +
    'Als ich je die Menschen gekannt,\n' +
    'Ich verstand die Stille des Äthers\n' +
    'Der Menschen Worte verstand ich nie.\n' +
    '\n' +
    'Mich erzog der Wohllaut\n' +
    'Des säuselnden Hains\n' +
    "Und lieben lernt' ich\n" +
    'Unter den Blumen.\n' +
    '\n' +
    'Im Arme der Götter wuchs ich groß.'
    ,
  poet: '荷尔德林',
  title: 'Da ich ein Knabe war'
}

export const data2: PureProps = {
  compositionId: 'pure',
  config: { wrap: true, scale: 1, noAuthorLabel: false },
  translators: '某某',
  title: `俄罗斯安魂曲七八`, // 俄罗斯安魂曲
  preface: `题献：“我不再渴望，因我必将永生。
–[澳] 斯该兰德.格雷尔`,
  poet: '中流砥柱',
  subtitle: `一.序曲`,
  date: '2022.12.12',
  location: '云南',
  poem: `那处风景我已经心仪很久
地图找不到它的坐标
月亮从此升起
流水也以此为源一路汹涌澎湃

我赶着一群蜜蜂四处搜寻
寻找那花香之地
日出之前，露水重重
日出之后，花影重重

我无所依靠但我无所畏惧
仅凭双手，我孤身进入荒芜之地
这处风景《心经》里有过记载
抚摸之后花儿次第盛开

一次次犁耙，一场场春雨下
一粒种子就开成了一树菩提花
我从千里之外爬山涉水
三秒钟敲开山里虚掩的僧寺家`
  }